import { getRowKey } from '../';
import { PERISCOPE_TAB_TYPES } from '@sonar-software/sonar-ts-constants';
import { queryParamsToDynamicQueryLanguageParams } from '@sonar-software/sonar-ts-lib';
import { ReportRow } from './ReportRow';
import { ReportSearchV3 } from './ReportSearchV3';
import { SelectionTable } from '@ui/tables';
import { v3ReportSortOptions } from './ReportSortOptions';
import { DynamicQueryOperator, SonarObjectType } from '@sonar-software/sonar-ts-types';
import { KeyPagination, keyPaginationDefaultQueryParams, keyPaginationFallbackQueryParams } from '@ui/KeyPagination';
import { useQueryResource, useSelectionTable } from '@hooks';
import React, { useCallback, useRef } from 'react';
const dqlTransform = (params) => queryParamsToDynamicQueryLanguageParams(params, {
    filterParams: {
        componentTypes: {
            name: 'ComponentTypeId',
            operator: DynamicQueryOperator.In
        },
        query: {
            name: 'DisplayName',
            operator: DynamicQueryOperator.Like
        }
    },
    orderingParams: {
        name: 'DisplayName'
    }
});
export const ReportSearchableSelectionTableV3 = ({ parentIndex, resourceIdsUri, uri }) => {
    const scrollableListRef = useRef(null);
    const { loading, resource, queryParams, updateParams } = useQueryResource({
        apiTransform: dqlTransform,
        defaultParams: Object.assign(Object.assign({}, keyPaginationDefaultQueryParams), { sortBy: v3ReportSortOptions[0].key, sortDirection: v3ReportSortOptions[0].direction }),
        fallbackParams: keyPaginationFallbackQueryParams,
        uri
    });
    const selectionData = useSelectionTable({
        getRowKey,
        queryParams,
        resourceIdsUri: resourceIdsUri,
        results: resource === null || resource === void 0 ? void 0 : resource.results,
        selectionType: SonarObjectType.SalesforceReport
    });
    const renderReport = useCallback((record) => React.createElement(ReportRow, { key: record.sonarObjectId, parentIndex: parentIndex, record: record }), [parentIndex]);
    const results = resource === null || resource === void 0 ? void 0 : resource.results;
    return (React.createElement(React.Fragment, null,
        React.createElement(ReportSearchV3, { onChange: updateParams, queryParams: queryParams }),
        React.createElement(SelectionTable, { dataSource: results, loading: loading, ref: scrollableListRef, renderRow: renderReport, rowKey: getRowKey, selectionData: selectionData, selectionType: PERISCOPE_TAB_TYPES.REPORTS }),
        React.createElement(KeyPagination, { defaultPageSize: Number(queryParams.count), listRef: scrollableListRef, onChange: updateParams, resource: resource })));
};
